import { customerApi } from './api';

export const customerAuthService = {
  sendOtp: async (phone) => {
    const response = await customerApi.post('/send-otp', { phone });
    return response.data;
  },

  verifyOtp: async (phone, otp) => {
    const response = await customerApi.post('/verify-otp', { phone, otp });
    if (response.data.success) {
      localStorage.setItem('customerToken', response.data.data.token);
      localStorage.setItem('customerData', JSON.stringify(response.data.data.customer));
    }
    return response.data;
  },

  loginWithFirebase: async (idToken, phone) => {
    const response = await customerApi.post('/firebase-login', { id_token: idToken, phone });
    if (response.data.success) {
      localStorage.setItem('customerToken', response.data.data.token);
      localStorage.setItem('customerData', JSON.stringify(response.data.data.customer));
    }
    return response.data;
  },

  logout: async () => {
    try {
      await customerApi.post('/logout');
    } finally {
      localStorage.removeItem('customerToken');
      localStorage.removeItem('customerData');
    }
  },

  getProfile: async () => {
    const response = await customerApi.get('/me');
    if (response.data.success) {
      localStorage.setItem('customerData', JSON.stringify(response.data.data));
    }
    return response.data;
  },
};
